import { I18nPluralPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideBadgeCheck, lucideClock } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmRadioGroupImports } from '@spartan-ng/helm/radio-group';
import { classes } from '@spartan-ng/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { Étape } from '../../../models/étape.model';

export const cardVariants = cva('gap-md px-md pt-sm pb-md flex w-full flex-col', {
  variants: {
    variant: {
      ouverte: '',
      fermee: 'bg-components-background-neutral-main',
    },
  },
  defaultVariants: {
    variant: 'ouverte',
  },
});

export type CardVariants = VariantProps<typeof cardVariants>;

@Component({
  selector: 'app-item-etape',
  imports: [ChipComponent, HlmRadioGroupImports, HlmIconImports, I18nPluralPipe],
  templateUrl: './item-etape.component.html',
  providers: [provideIcons({ lucideClock, lucideBadgeCheck })],
})
export class ItemEtapeComponent {
  readonly etape = input.required<Étape>();

  public readonly variant = computed<CardVariants['variant']>(() => (this.etape().estOuverte ? 'ouverte' : 'fermee'));

  readonly certification = computed(() =>
    this.etape().estCertifiante
      ? this.etape().certification?.nom + ' - ' + this.etape().certification?.codeFiche
      : 'Non certifiante',
  );

  protected readonly anMapping: { [k: string]: string } = {
    '=0': '# an',
    '=1': '# an',
    other: '# ans',
  };

  constructor() {
    classes(() => cardVariants({ variant: this.variant() }));
  }
}
